export { RoosterProps } from './type/RoosterProps';
export { Rooster } from './component/Rooster';
